import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-our-tracking',
  templateUrl: './our-tracking.component.html',
  styleUrls: ['./our-tracking.component.scss']
})
export class OurTrackingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
